import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import css from './PhoneNumberFields.module.css';
import i18n from 'i18next';
import classNames from 'classnames';
import FormInput from '../FormInput';
import { FormItem } from '../FormItem';
import MobileDetect from 'mobile-detect';
import FormSelectCountryNoBorder from '../FormSelectCountry/FormSelectCountryNoBorder';
import FormSelectCountryPopup from '../FormSelectCountry/FormSelectCountryPopup';

const md = new MobileDetect(window.navigator.userAgent);
const os = md.os();
const isMobile = os === 'AndroidOS' || os === 'iOS';

type Props = {
  onUserEditCountryCode?: (v: any) => void;
  className?: string;
  disabled?: boolean;
  noMarginTop?: boolean;
  optional?: boolean;
};

const PhoneNumberFields2 = (props: Props) => {
  const { className, disabled, noMarginTop = false, onUserEditCountryCode, optional = false } = props;
  const [countryOption, setCountryOption] = useState(null);
  const onUserSelectCountry = useCallback((v) => {
    console.log('onEdit', v);
    if (!!v) {
      onUserEditCountryCode?.(v);
    }
  }, []);

  return (
    <div className={classNames(className, css.container, noMarginTop && css.noMarginTop)}>
      <FormItem
        style={{ flexGrow: 1 }}
        name="phoneNumberUserInput"
        rules={[
          ...(!optional ? [{ required: true, message: i18n.t('msg:pleaseInput', { field: i18n.t('label:phoneNumber') }) }] : []),
          {
            pattern: /^[0-9 \-()]+$/,
            message: i18n.t('msg:fieldInvalid', { field: i18n.t('label:phoneNumber') }),
          },
        ]}
      >
        <FormInput
          prefixElement={
            <Form.Item
              validateTrigger={'onChange'}
              rules={optional ? [] : [{ required: true, message: i18n.t('msg:pleaseSelect', { field: i18n.t('label:countryCode') }) }]}
              name="phoneNumberCountryCode"
              noStyle
            >
              {isMobile ? (
                <FormSelectCountryPopup
                  border={false}
                  showCallingCode={true}
                  placeholder={i18n.t('label:countryCode')}
                  disabled={disabled}
                  className={css.select}
                />
              ) : (
                <FormSelectCountryNoBorder
                  onUserSelect={onUserSelectCountry}
                  disabled={disabled}
                  placeholder={i18n.t('label:countryCode')}
                />
              )}
            </Form.Item>
          }
          autoComplete={'tel-local'}
          label={i18n.t('label:phoneNumber')}
          placeholder={i18n.t('label:phoneNoCountryCode')}
          type={'tel'}
          disabled={disabled}
          name={'phone'}
          className={css.input}
          isRequired={false}
        />
      </FormItem>
    </div>
  );
};

export default PhoneNumberFields2;
